var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "h1",
          { staticClass: "catalogTitle" },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.category.title) + "\n            "
            ),
            _vm.isSearchPage
              ? [
                  _vm._v("\n                " + _vm._s(_vm.i18n("for")) + " '"),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.queryString) }
                  }),
                  _vm._v("'\n            ")
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c("LazyHydrate", { attrs: { never: "" } }, [
          _c("div", {
            staticClass: "catalogMainText",
            domProps: { innerHTML: _vm._s(_vm.mainText) }
          })
        ]),
        _vm._v(" "),
        _vm.category.banner
          ? _c("picture", { staticClass: "category-banner" }, [
              _c("source", {
                attrs: {
                  media: "(min-width: 992px)",
                  srcset:
                    _vm.category.banner["1140"] +
                    ", " +
                    _vm.category.banner["2280"] +
                    " 2x"
                }
              }),
              _vm._v(" "),
              _c("source", {
                attrs: {
                  media: "(min-width: 481px)",
                  srcset: "" + _vm.category.banner["720"]
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "mb-20",
                attrs: {
                  src: _vm.category.banner["480"],
                  fetchpriority: "high",
                  alt: ""
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("LazyHydrate", { attrs: { never: "" } }, [
          _vm.category.isContentMode || _vm.category.isMixedMode
            ? _c("div", { domProps: { innerHTML: _vm._s(_vm.cmsBlock) } })
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }